import { Component, Input, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { UserModel } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit {
  @Input() user: UserModel = {} as UserModel;
  @Input() sidenav: MatSidenav;
  constructor(
    private userService: UserService
  ) { }
  ngOnInit(): void {
  }
  logout(): void {
    this.userService.logout();
  }
}
